import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import { IMAGES } from '../../constants/images';
import '../../css/StoreDecisionModal.css';

const StoreDecisionModal = ({
  isOpen,
  storeName,
  description = '신규 가맹 신청을 승인하시겠습니까?',
  loading = false,
  onClose,
  onSubmit,
}) => {
  const [reason, setReason] = useState('');

  useEffect(() => {
    if (isOpen) {
      setReason('');
    }
  }, [isOpen]);

  if (!isOpen) return null;

  const handleApprove = () => {
    if (loading) return;
    onSubmit?.(true, '');
  };

  const handleReject = () => {
    if (loading) return;
    onSubmit?.(false, reason);
  };

  const handleOverlayClick = () => {
    if (!loading) {
      onClose?.();
    }
  };

  return (
    <div className="decision-modal-overlay" onClick={handleOverlayClick}>
      <div className="decision-modal" onClick={(e) => e.stopPropagation()}>
        <button className="modal-close" onClick={onClose} disabled={loading}>
          <img src={IMAGES.EXIT} alt="닫기" />
        </button>
        <h3>{storeName || '가맹점'}</h3>
        <p>{description}</p>
        <div className="decision-actions">
          <button className="approve-btn" onClick={handleApprove} disabled={loading}>
            승인
          </button>
          <button className="reject-btn" onClick={handleReject} disabled={loading}>
            거절
          </button>
        </div>
        <textarea
          placeholder="거절 시 사유를 입력해주세요"
          value={reason}
          onChange={(e) => setReason(e.target.value)}
          disabled={loading}
        />
        <button className="link-button" onClick={onClose} disabled={loading}>
          등록정보 다시보기
        </button>
      </div>
    </div>
  );
};

StoreDecisionModal.propTypes = {
  isOpen: PropTypes.bool.isRequired,
  storeName: PropTypes.string,
  description: PropTypes.string,
  loading: PropTypes.bool,
  onClose: PropTypes.func.isRequired,
  onSubmit: PropTypes.func.isRequired,
};

export default StoreDecisionModal;
